import React from "react";
import "./SkeletonLoaderAboutUs.css";

const SkeletonLoaderAboutUs = () => {
  return (
    <div className="container container--large skeleton-about-us" style={{paddingTop:'10%'}}>

         {/* Image */}
         <div className="skeleton-image-large" />
      {/* Section 1 */}
      <div className="skeleton-section">
        <div className="col-md-8">
        <div className="skeleton-heading" />
        <div className="skeleton-paragraph" />
        <div className="skeleton-paragraph" />
        <div className="skeleton-paragraph" />
        </div>
      </div>

      {/* Section 2 */}
      <div className="skeleton-section">
        <div className="skeleton-heading" />
      </div>

      {/* Image and Text Section */}
      <div className="skeleton-image-content">
        {Array.from({ length: 4 }).map((_, index) => (
          <div
            key={index}
            className={`skeleton-image-content__row ${
              index % 2 === 0
                ? "skeleton-image-content__row-odd"
                : "skeleton-image-content__row-even"
            }`}
          >
            {/* Image */}
            <div className="skeleton-image" />

            {/* Text */}
            <div className="skeleton-text-block">
              <div className="skeleton-heading" />
              <div className="skeleton-paragraph" />
              <div className="skeleton-paragraph" />
            </div>
          </div>
        ))}
      </div>

      {/* Section 3 */}
      <div className="skeleton-section text-center">
        <div className="skeleton-heading" />
        <div className="skeleton-paragraph" />
      </div>

      {/* OwlCarousel Skeleton */}
      <div className="skeleton-carousel">
        {Array.from({ length: 5 }).map((_, index) => (
          <div className="skeleton-carousel-card" key={index}>
            <div className="skeleton-carousel-image" />
            <div className="skeleton-carousel-body">
              <div className="skeleton-paragraph" />
              <div className="skeleton-paragraph" />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default SkeletonLoaderAboutUs;
